export default __webpack_public_path__ + "static/media/ic_ahu_temperature.821f3d95.svg";